import { render } from "./SummaryListItem.vue?vue&type=template&id=450ffb44"
import script from "./SummaryListItem.vue?vue&type=script&lang=js"
export * from "./SummaryListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__